import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/enviroments';
import {
  CesionarioSummaries,
  DailyAmount,
  DailyDocs,
  DashboardAddClient,
  DashboardAddClientbyRut,
  NewDebtor,
  Proveedor,
  ValidClient,
} from '../interface/data.interface';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { DebtorsBlackListMarckOrUnmarck, DebtorsFavoriteListMarckOrUnmarck, debtorsResponse } from '../../clients/interface/data.interface';
import { Observable } from 'rxjs';
import { ActionResponseDTO } from 'src/app/common/interfaces/action-result.interface';

@Injectable({
  providedIn: 'root',
})
export class CompaniesFactoringService {
  constructor(private http: HttpClient) {}
  // getCompanies(start:any, end:any){
  //   const endpoint = `${environment.apiUrl}/Invoice/factoring/dashboard?start=${start}&end=${end}`;
  //   return this.http.get<GlobalData>(endpoint);

  // }

  getProveedor(
    start: any,
    end: any,
    page: number,
    search: string,
    size: number,
    sii: boolean | null
  ) {
    const siiQuery = sii != null ? `&sii=${sii}` : '';
    const endpoint = `${environment.apiUrl}/DashboardFactoring/proveedores?start=${start}&end=${end}&page=${page}&search=${search}&size=${size}${siiQuery}`;
    return this.http.get<PageResult<Proveedor>>(endpoint);
  }

  addCompanies(value: DashboardAddClient) {
    console.log(value);
    const endpoint = `${environment.apiUrl}/DashboardFactoring/RegistrarClientes`;
    return this.http.post<any>(endpoint, value);
  }
  addNewCompanies(value: DashboardAddClientbyRut) {
    console.log(value);
    const endpoint = `${environment.apiUrl}/Company/AddCompaniesByRut`;
    return this.http.post<any>(endpoint, value);
  }

  validClient(data: ValidClient) {
    console.log(data);
    const endpoint = `${environment.apiUrl}/Company/validUser`;
    return this.http.post<any>(endpoint, data);
  }

  getProveedorByName(value: any) {
    const { primerDia, ultimoDia, nombre } = value;
    const endpoint = `${environment.apiUrl}/DashboardFactoring/proveedores?start=${primerDia}&end=${ultimoDia}&search=${nombre}`;
    return this.http.get<Proveedor>(endpoint);
  }
  getDailyAmountProveedorName(value: any) {
    const { primerDia, ultimoDia, nombre } = value;
    const endpoint = `${environment.apiUrl}/DashboardFactoring/daily/amount?start=${primerDia}&end=${ultimoDia}&search=${nombre}`;
    return this.http.get<DailyAmount>(endpoint);
  }

  getDailyAmountProveedor(start: any, end: any) {
    const endpoint = `${environment.apiUrl}/DashboardFactoring/daily/amount?start=${start}&end=${end}`;
    return this.http.get<DailyAmount>(endpoint);
  }

  getCesionarios(start: any, end: any, search: string) {
    const endpoint = `${environment.apiUrl}/DashboardFactoring/cesionarios?start=${start}&end=${end}&search=${search}`;
    return this.http.get<CesionarioSummaries>(endpoint);
  }

  getDocs(start: any, end: any) {
    const endpoint = `${environment.apiUrl}/DashboardFactoring/daily/docs?start=${start}&end=${end}`;
    return this.http.get<DailyDocs>(endpoint);
  }

  getCesionariosName(value: any) {
    const { primerDia, ultimoDia, nombre } = value;
    console.log(value);
    const endpoint = `${environment.apiUrl}/DashboardFactoring/cesionarios?start=${primerDia}&end=${ultimoDia}&search=${nombre}`;
    return this.http.get<CesionarioSummaries>(endpoint);
  }

  getDocsName(value: any) {
    const { primerDia, ultimoDia, nombre } = value;

    const endpoint = `${environment.apiUrl}/DashboardFactoring/daily/docs?start=${primerDia}&end=${ultimoDia}&search=${nombre}`;
    return this.http.get<DailyDocs>(endpoint);
  }

  addDebtor(value: NewDebtor) {
    const endpoint = `${environment.apiUrl}/DashboardFactoring/RegistrarDeudor`;
    return this.http.post<any>(endpoint, value);
  }

  getAllDebtorsList(request: any) : Observable<PageResult<debtorsResponse>> {
    let queryParams = new HttpParams()
    .set('page', request.page)
    .set('size', request.size)
    .set('search', request.search)
    .set('sortOrder', request.sortOrder);
    const endpoint = `${environment.apiUrl}/DashboardFactoring/getAllDebtorList`;
    return this.http.get<PageResult<debtorsResponse>>(endpoint, {params: queryParams});
  }

  getDebtorsFavorite(request: any) : Observable<PageResult<debtorsResponse>> {
    let queryParams = new HttpParams()
    .set('page', request.page)
    .set('size', request.size)
    .set('search', request.search)
    .set('sortOrder', request.sortOrder);
    const endpoint = `${environment.apiUrl}/DashboardFactoring/getFavoriteDebtors`;
    return this.http.get<PageResult<debtorsResponse>>(endpoint, {params: queryParams});
  }

  getDebtorsBlackList(request: any) : Observable<PageResult<debtorsResponse>> {
    let queryParams = new HttpParams()
    .set('page', request.page)
    .set('size', request.size)
    .set('search', request.search)
    .set('sortOrder', request.sortOrder);
    const endpoint = `${environment.apiUrl}/DashboardFactoring/getBlackListDebtors`;
    return this.http.get<PageResult<debtorsResponse>>(endpoint, {params: queryParams});
  }

  updateDebtorFavorite(request: number) {
    const endpoint = `${environment.apiUrl}/DashboardFactoring/${request}/favoriteDebtorCheckOrUncheck`;
    return this.http.patch<ActionResponseDTO<DebtorsFavoriteListMarckOrUnmarck>>(endpoint, null);
  }

  updateDebtorBalackList(request: number) {
    const endpoint = `${environment.apiUrl}/DashboardFactoring/${request}/blackListDebtorCheckOrUncheck`;
    return this.http.patch<ActionResponseDTO<DebtorsBlackListMarckOrUnmarck>>(endpoint, null);
  }

}
